import { render, staticRenderFns } from "./ModalFinalizar.vue?vue&type=template&id=31b9bb18&scoped=true"
import script from "./ModalFinalizar.vue?vue&type=script&lang=js"
export * from "./ModalFinalizar.vue?vue&type=script&lang=js"
import style0 from "./ModalFinalizar.vue?vue&type=style&index=0&id=31b9bb18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b9bb18",
  null
  
)

export default component.exports